module.exports = __webpack_public_path__ + "static/img/ZRS4261_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ZRS4261_1.png
// module id = 1TwE
// module chunks = 0